import { ART } from '../../constants';
import { IShoppingItem, IShoppingProduct } from '@inter-ikea-kompis/types';
import { tacMiddleware } from './conversionMiddleware';
import { unique } from '../array';
import articles from '../../services/products/articles';
import productService from '../../services/products';
import tacHelpers from '../../state/tac/tacHelpers';
import { TacItem, IowsArticle } from '../../generalTypes';
import { TacModel } from '../../state/tac/tacTypes';
// TODO: IArticleData is expected to officially exported in the next version of the DPC.
// When this happens, change so that we import IArticleData the same way as we currently import IItems.
import IArticleData from '@insights/insights-data-provider/lib/types/IArticleData';
import { IItems } from '@insights/insights-data-provider';
import store from '../../state';
import { selectYMALContent } from '../../state/ymal/ymalSelectors';
import { selectCurrencyCode } from '../../state/dexfSettings/dexfSettingsSelectors';

/**
 *
 * @param tac
 * @returns Array of all valid products in TAC
 */
function getAllValidProducts(tac: TacModel): TacItem[] {
  return tacHelpers
    .getAllItems(tac.items)
    .map((item: TacItem) => productService.getProduct(item))
    .filter(Boolean);
}

/**
 *
 * @param tac
 * @returns Array of Kompis2 Shopping Products
 */
export function getShoppingProductsFromTAC(tac: TacModel): IShoppingProduct[] {
  return getShoppingItemsFromTAC(tac).map(item => ({
    quantity: item.quantity,
    product: { ...articles.getArticle(item.id) },
  }));
}

/**
 *
 * @param tac
 * @param preferLocalIds
 * @returns Array of Kompis2 Shopping Items
 */
export function getShoppingItemsFromTAC(
  tac: TacModel,
  preferLocalIds: boolean = false
): IShoppingItem[] {
  const items = getAllValidProducts(tac);
  return getShoppingItems(items, preferLocalIds);
}

/**
 *
 * @param tacItems
 * @param preferLocalIds
 * @returns Array of Kompis2 Shopping Items
 */
export function getShoppingItems(
  tacItems: TacItem[],
  preferLocalIds: boolean = false
): IShoppingItem[] {
  const allIows = tacMiddleware(tacItems).flatMap((prod: TacItem) => prod.iows);

  return allIows
    .map((iows: IowsArticle) => iows.itemno)
    .filter(unique)
    .map((itemno: string) => ({
      id: preferLocalIds
        ? articles.getArticle(itemno)?.content?.ruItemNo
        : itemno,
      type: ART,
      quantity: allIows
        .filter((iows: IowsArticle) => iows.itemno === itemno)
        .reduce((acc: number, curr: IowsArticle) => acc + curr.qty, 0),
    }));
}

export function getInsightsArticleData(
  shoppingItems: IShoppingItem[]
): IArticleData[] {
  const articleData = shoppingItems.map(item => {
    const content =
      articles.getArticleContent(item.id) ||
      selectYMALContent(store.getState(), item.id);
    return {
      id: item.id,
      price: content.priceInformation.salesPrice[0].priceInclTax,
      qty: item.quantity,
    };
  });
  return articleData;
}

export function getInsightsItems(shoppingItems: IShoppingItem[]): IItems {
  const articleData = getInsightsArticleData(shoppingItems);
  const currency = selectCurrencyCode(store.getState());
  return { currency: currency, items: articleData };
}
